import { render, staticRenderFns } from "./ReportLelang.vue?vue&type=template&id=e880169e"
import script from "./ReportLelang.vue?vue&type=script&lang=js"
export * from "./ReportLelang.vue?vue&type=script&lang=js"
import style0 from "./ReportLelang.vue?vue&type=style&index=0&id=e880169e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports